"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restrictToMinuteStep = exports.restrictToMinDate = exports.restrictToMaxDate = exports.normalizeTimeWithOffset = exports.joinDates = exports.isToday = exports.getStartOfTheDay = exports.getEndOfTheDay = exports.formatDate = exports.checkIsEqualTime = exports.calcJewishYear = void 0;
var _strings = require("./strings");
const formatDate = function (dateTime) {
  let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '{day}.{month}.{year} {hour}:{minute}';
  return format.replace('{day}', (0, _strings.padNumberWithPrefixZero)(dateTime.getDate())).replace('{month}', (0, _strings.padNumberWithPrefixZero)(dateTime.getMonth() + 1)).replace('{year}', dateTime.getFullYear().toString()).replace('{hour}', (0, _strings.padNumberWithPrefixZero)(dateTime.getHours())).replace('{minute}', (0, _strings.padNumberWithPrefixZero)(dateTime.getMinutes()));
};
exports.formatDate = formatDate;
const isToday = date => {
  const today = new Date();
  return date.toDateString() === today.toDateString();
};
exports.isToday = isToday;
const getStartOfTheDay = function (date) {
  let startTodayFromNow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const fixedDate = new Date(date);
  if (startTodayFromNow && isToday(date)) {
    const now = new Date();
    fixedDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
  } else {
    fixedDate.setHours(0, 0, 0, 0);
  }
  return fixedDate;
};
exports.getStartOfTheDay = getStartOfTheDay;
const getEndOfTheDay = date => {
  const fixedDate = new Date(date);
  fixedDate.setHours(23, 59, 59, 0);
  return fixedDate;
};
exports.getEndOfTheDay = getEndOfTheDay;
const restrictToMinDate = (date, minDate) => {
  if (date && minDate) {
    const minDateObj = new Date(minDate);
    if (date.getTime() < minDateObj.getTime()) {
      return minDateObj;
    }
  }
  return date;
};
exports.restrictToMinDate = restrictToMinDate;
const restrictToMaxDate = (date, maxDate) => {
  if (date && maxDate) {
    const maxDateObj = new Date(maxDate);
    if (date.getTime() > maxDateObj.getTime()) {
      return maxDateObj;
    }
  }
  return date;
};
exports.restrictToMaxDate = restrictToMaxDate;
const restrictToMinuteStep = function (date, minuteStep) {
  let roundUp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const fixedDateTime = new Date(date);
  const minutes = date.getMinutes();
  if (typeof minuteStep === 'number' && minuteStep > 1 && minutes % minuteStep > 0) {
    const fixedMinutes = Math.ceil(minutes / minuteStep) * minuteStep % 60;
    const deltaMinutes = fixedMinutes > 0 ? fixedMinutes - minutes : 60 - minutes;
    if (roundUp) {
      fixedDateTime.setTime(date.getTime() + deltaMinutes * 60 * 1000);
    } else {
      fixedDateTime.setTime(date.getTime() - (minuteStep - deltaMinutes) * 60 * 1000);
    }
    fixedDateTime.setSeconds(0, 0);
  }
  return fixedDateTime;
};
exports.restrictToMinuteStep = restrictToMinuteStep;
const calcJewishYear = year => {
  const letters = {
    1: 'א',
    2: 'ב',
    3: 'ג',
    4: 'ד',
    5: 'ה',
    6: 'ו',
    7: 'ז',
    8: 'ח',
    9: 'ט',
    10: 'י',
    20: 'כ',
    30: 'ל',
    40: 'מ',
    50: 'נ',
    60: 'ס',
    70: 'ע',
    80: 'פ',
    90: 'צ',
    100: 'ק',
    200: 'ר',
    300: 'ש',
    400: 'ת'
  };
  let units, dozens, hundreds, rest;
  let civilYear = year - 1240;
  let result = '';
  units = civilYear % 10;
  civilYear -= units;
  dozens = civilYear % 100;
  civilYear -= dozens;
  hundreds = civilYear % 400;
  civilYear -= hundreds;
  rest = civilYear / 400;
  for (let i = 0; i < rest; i++) {
    if (!hundreds && i === rest - 1) {
      result += '"';
    }
    result += 'ת';
  }
  if (hundreds) {
    if (!dozens) {
      result += '"';
    }
    result += letters[hundreds];
  }
  if (dozens) {
    if (!units) {
      result += '"';
    }
    result += letters[dozens];
  }
  if (units) {
    result += '"';
    result += letters[units];
  }
  return result;
};
exports.calcJewishYear = calcJewishYear;
const checkIsEqualTime = (t1, t2) => {
  const dayStr = date => {
    //todo: fix
    let day = date.getDate();
    day = day < 10 ? '0' + day : '' + day;
    let month = date.getMonth() + 1;
    month = month < 10 ? '0' + month : '' + month;
    let year = date.getFullYear();
    year = ('' + year).slice(2);
    let hours = date.getHours();
    hours = hours < 10 ? '0' + hours : '' + hours;
    let minutes = date.getMinutes();
    minutes = minutes < 10 ? '0' + minutes : '' + minutes;
    return `${year}${month}${day}${hours}${minutes}`;
  };
  if (t1 && t2) {
    const str1 = dayStr(t1);
    const str2 = dayStr(t2);
    return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
  }
  return 0;
};
exports.checkIsEqualTime = checkIsEqualTime;
const normalizeTimeWithOffset = time => {
  var newTime = new Date(time.getTime());
  if (newTime) newTime.setHours(newTime.getHours() - newTime.getTimezoneOffset() / 60);
  return newTime;
};
exports.normalizeTimeWithOffset = normalizeTimeWithOffset;
const joinDates = (date, time) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), 0);
};
exports.joinDates = joinDates;